import { useMemo, useReducer } from "react"
import { useParams } from "react-router-dom"

import { multipleDateRangeReducer } from "helpers/reducers/dateRangeReducer"
import useDevices from "helpers/hooks/useDevices"
import AlertsContext from "widgets/alerts/AlertsContext"
import AlertsTabView from "widgets/alerts/AlertsTabView"
import ActivityPanel from "widgets/alerts/ActivityPanel"
import NewAlertSettingButton from "widgets/alerts/settings/NewAlertSettingButton"
import Message from "widgets/common/Message"
import { BodyContainer } from "widgets/styled/containers"
import TowerAlertsContent from "widgets/towers/TowerAlertsContent"

const TowerAlerts = () => {
  const { id } = useParams()
  const { getLessIdFromTowerId } = useDevices()
  const [multipleDateRange, dispatchMultipleDateRange] = useReducer(
    multipleDateRangeReducer,
    {},
  )

  const virtualTowerId = useMemo(
    () => getLessIdFromTowerId(Number(id)),
    [getLessIdFromTowerId, id],
  )

  return (
    <AlertsContext.Provider
      value={{
        multipleDateRange,
        dispatchMultipleDateRange,
      }}
    >
      <BodyContainer disableGutters maxWidth="xl">
        <AlertsTabView
          tabsConfig={{
            configuredAlerts: <TowerAlertsContent />,
            activity: virtualTowerId ? (
              <ActivityPanel devicesIds={[virtualTowerId]} />
            ) : (
              <Message messageKey={"generic.NO_DATA_IN_TIME_WINDOW"} />
            ),
          }}
          actions={{
            configuredAlerts: (
              <NewAlertSettingButton entity="tower" entityId={Number(id)} />
            ),
          }}
        />
      </BodyContainer>
    </AlertsContext.Provider>
  )
}

export default TowerAlerts
